// Start aplikace: přihlášení, načtení dat z databáze, realtime.
// (Krok B1b: rozděleno ze src/app.js beze změny kódu; importy/exporty doplněny automaticky.)
import { DASHBOARD_KEY, NOK_THRESHOLD_DEFAULT, SCHEDULE_LATE_DEFAULT, SCHEDULE_START_WINDOW_DEFAULT, SCORE_FACTORY_DEFAULT, dashboardConfig, parseDashboardConfig, queueWrite, saveDashboardConfig, setDashboardConfig, showToast, state } from './state.js';
import { updateBrandingHeader } from './companies.js';
import { render } from '../main-render.js';

// ---------- boot ----------
// Napojení na databázi, úložiště, přihlášení a stahování (window.claude) —
// nastaví boot(), ostatní části je jen čtou.
var db = null, assetsCap = null, userCap = null, downloadsCap = null;
function boot(){
  // Pro testy: jsou načtená všechna data? (tests/run.js čeká na tohle místo pevné pauzy)
  window.__dataReady = function(){ for(var k in state.ready){ if(!state.ready[k]) return false; } return true; };
  render();
  (async function(){
    db = await claude.use('db').catch(function(){ return null; });
    assetsCap = await claude.use('assets').catch(function(){ return null; });
    userCap = await claude.use('user').catch(function(){ return null; });
    downloadsCap = await claude.use('downloads').catch(function(){ return null; });
    if(userCap){
      try{
        var me = await userCap.me();
        state.meName = me.name || '';
        state.isOwner = !!me.isOwner;
        state.canEditPlatform = !!me.canEdit;
        state.myId = me.id || null;
        state.meEmail = me.email || '';
        state.meAvatarUrl = me.avatarUrl || '';
        state.meColor = me.color || '';
      }catch(e){}
      try{
        var dw = await userCap.can('data.write');
        state.canWriteData = dw!==false; // null (unknown) or true -> assume can, let a rejected write decide
      }catch(e){ state.canWriteData = true; }
    }
    render();
    if(!db){
      state.dbMissing = true;
      document.getElementById('topbarSub').textContent = 'Bez přístupu k datům';
      render();
      return;
    }
    subscribe();
  })();
}

function onDbError(label){
  return function(e){
    console.error(label, e);
    if(e && e.code==='revoked'){ showToast('Přístup k datům byl odebrán.'); }
  };
}

function subscribe(){
  db.collection('roles').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.roles = m; state.rolesReady = true;
    render();
  }, onDbError('roles'));

  db.collection('workplaces').orderBy('order','asc').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.workplaces = m; state.ready.workplaces = true;
    render();
  }, onDbError('workplaces'));

  db.collection('branches').orderBy('order','asc').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.branches = m; state.ready.branches = true;
    render();
  }, onDbError('branches'));

  db.collection('companies').orderBy('order','asc').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.companies = m; state.ready.companies = true;
    render();
  }, onDbError('companies'));

  db.collection('auditTypes').orderBy('order','asc').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.auditTypes = m; state.ready.auditTypes = true;
    render();
  }, onDbError('auditTypes'));

  db.collection('groups').orderBy('order','asc').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.groups = m; state.ready.groups = true;
    render();
  }, onDbError('groups'));

  db.collection('questions').orderBy('order','asc').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.questions = m; state.ready.questions = true;
    render();
  }, onDbError('questions'));

  db.collection('subquestions').orderBy('order','asc').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.subquestions = m; state.ready.subquestions = true;
    render();
  }, onDbError('subquestions'));

  db.collection('profiles').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.profiles = m; state.ready.profiles = true;
    if(state.myId && m.has(state.myId)){
      var p = m.get(state.myId);
      // Keep state.meName (used e.g. for "changedBy" on opatření status
      // history) in sync with the profile's displayName as it changes —
      // otherwise a rename wouldn't show up until a full app reload.
      if(p.displayName) state.meName = p.displayName;
      // Rozložení dashboardu je sdílené v rámci účtu (profil v DB). Pokud už
      // je v profilu uložené, je to zdroj pravdy — promítnout ho sem (i při
      // změně z jiného zařízení). Pokud ještě není (první spuštění po této
      // úpravě), "vyfotit" aktuální lokální konfiguraci z tohoto zařízení
      // jako první sdílenou verzi, aby se nic neztratilo.
      if(p.dashboardSettings){
        setDashboardConfig(parseDashboardConfig(p.dashboardSettings));
        try{ localStorage.setItem(DASHBOARD_KEY, JSON.stringify(dashboardConfig)); }catch(e){}
      } else if(!state.dashboardSeeded){
        state.dashboardSeeded = true;
        // Hned (ne se zpožděním jako běžné ukládání) — pozdější překreslení
        // po zápisu by jinak zavřelo formulář, který uživatel mezitím otevřel.
        var seed = dashboardConfig;
        queueWrite(function(){ return db.doc('profiles/'+state.myId).update({dashboardSettings:seed}); });
      }
    }
    render();
  }, onDbError('profiles'));

  db.collection('appSettings').onSnapshot(function(snap){
    var b = null, st = null, ss = null, nt = null, sl = null, ttl = null, fy = null, pq = null;
    snap.docs.forEach(function(d){
      if(d.id==='branding') b = d.data();
      if(d.id==='scoreThresholds') st = d.data();
      if(d.id==='scheduleStart') ss = d.data();
      if(d.id==='nokThreshold') nt = d.data();
      if(d.id==='scheduleLate') sl = d.data();
      if(d.id==='openAuditTtl') ttl = d.data();
      if(d.id==='fiscalYear') fy = d.data();
      if(d.id==='publicQr') pq = d.data();
    });
    state.nokThresholdDefault = (nt && typeof nt.count==='number' && nt.count>=1) ? nt.count : NOK_THRESHOLD_DEFAULT;
    state.branding = b || {companyName:'', logoAssetId:'', logoUrl:''};
    state.scoreDefaults = (st && typeof st.good==='number' && typeof st.bad==='number') ? {good:st.good, bad:st.bad} : Object.assign({}, SCORE_FACTORY_DEFAULT);
    state.scheduleStartWindowDays = (ss && typeof ss.days==='number' && ss.days>=0) ? ss.days : SCHEDULE_START_WINDOW_DEFAULT;
    state.scheduleLateDays = (sl && typeof sl.days==='number' && sl.days>=0) ? sl.days : SCHEDULE_LATE_DEFAULT;
    state.openAuditTtlHours = (ttl && typeof ttl.hours==='number' && ttl.hours>=1) ? ttl.hours : null;
    state.fiscalStartMonth = (fy && typeof fy.startMonth==='number' && fy.startMonth>=1 && fy.startMonth<=12) ? fy.startMonth : 1;
    state.publicQr = !!(pq && pq.enabled===true);
    state.ready.branding = true;
    updateBrandingHeader();
    render();
  }, onDbError('appSettings'));

  db.collection('correctiveActions').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.correctiveActions = m; state.ready.correctiveActions = true;
    render();
  }, onDbError('correctiveActions'));

  // Odpovědné osoby = uživatelé (2026-10-31): tabulka responsible_persons se už nenačítá.

  db.collection('schedules').orderBy('createdAt','asc').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.schedules = m; state.ready.schedules = true;
    render();
  }, onDbError('schedules'));

  // Podněty (RLS: autor své, Administrátor všechny v organizaci).
  db.collection('feedback').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.feedback = m; state.ready.feedback = true;
    render();
  }, onDbError('feedback'));

  db.collection('delegations').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.delegations = m;
    render();
  }, onDbError('delegations'));

  db.collection('auditorGroups').onSnapshot(function(snap){
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.auditorGroups = m; state.ready.auditorGroups = true;
    render();
  }, onDbError('auditorGroups'));

  // Audity se načítají jen pro aktivní firmu (ensureAuditsScope, volá render).
  ensureAuditsScope();
}

// Audity jen aktivní firmy (rozhodnutí uživatele 2026-10-31 — rychlejší start
// a méně dat): odběr se založí, až je známá aktivní firma, a při přepnutí firmy
// se vymění. Starší audity bez companyId patří všem (stejně jako dřív).
var auditsUnsub = null, auditsScope = null;
function ensureAuditsScope(){
  if(!db || !state.ready.companies) return;
  var companyId = state.currentCompanyId || '';
  var scopeKey = 'c:' + companyId;
  if(auditsScope === scopeKey) return;
  auditsScope = scopeKey;
  if(auditsUnsub){ try{ auditsUnsub(); }catch(e){} auditsUnsub = null; }
  state.ready.audits = false;
  state.audits = new Map();
  auditsUnsub = db.collection('audits').where('companyId', companyId).onSnapshot(function(snap){
    if(auditsScope !== scopeKey) return; // mezitím přepnuto na jinou firmu
    var m = new Map();
    snap.docs.forEach(function(d){ m.set(d.id, d.data()); });
    state.audits = m; state.ready.audits = true;
    var auditWasRemoved = false;
    if(state.activeAuditId && !m.has(state.activeAuditId)){
      state.activeAuditId = null; state.draftAudit = null;
      auditWasRemoved = true;
    }
    // While an audit is actively being filled in, this client's own writes
    // (persistDraft, fired on blur of "odpovědná osoba"/popis and on every
    // change of the due-date picker) echo straight back through this same
    // realtime subscription a moment later. A full render() here would
    // rebuild the whole audit-runner screen from scratch mid-edit, kicking
    // focus out of whatever field the user had just clicked into — or, for
    // the native date input, destroying it right as its picker opens,
    // which snaps the picker shut immediately. The runner reads from
    // state.draftAudit (a local working copy), not state.audits, so
    // skipping this render while a draft is open loses nothing: the audit
    // list/dashboard simply pick up the latest state.audits on their own
    // next render, and closing/cancelling the draft already renders itself.
    if(state.draftAudit && !auditWasRemoved) return;
    render();
  }, onDbError('audits'));
}

export {
  assetsCap,
  ensureAuditsScope,
  boot,
  db,
  downloadsCap,
  userCap
};
